<template>
  <div class=" wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <LeftLayout />
      <HeaderLayout />
      <main class="reset-css">
        <div class="container">
          <!-- Head section -->
          <div>
            <span class="title">
              코스 선택
            </span>
          </div>

          <!-- Content section -->
          <div class="">
            <ul class=" club">
              <li
                v-for="(club, index) in clubs"
                class="club__item"
                :class="{
                  active: chosenClubIndex === index
                }"
                :key="club.ccode"
                @click="() => onClubClick(club, index)"
              >
                {{ club.club_name }}
              </li>
            </ul>
          </div>
        </div>
      </main>
      <FooterLayout />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import FooterLayout from '../components/layout/Footer.vue'
import HeaderLayout from '../components/layout/Header.vue'
import LeftLayout from '../components/layout/Left.vue'
import { aplManagerService } from '../router'

export default {
  name: 'AccountClubs',

  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },

  data() {
    return {
      clubs: undefined
    }
  },

  computed: {
    ...mapState('clubs', { chosenClubIndex: state => state.chosenClubIndex })
  },

  methods: {
    ...mapMutations('clubs', { setClubIndex: 'SET_CLUB_INDEX' }),

    async initFetch() {
      try {
        const { accountId } = this.userInfo
        if (!accountId) throw new Error('사용자 정보가 올바르지 않습니다.')

        const { clubs } = await aplManagerService.getAccountGolfClubs(accountId)

        this.clubs = clubs
      } catch (err) {
        console.warn(err)
      }
    },

    onClubClick(club, index) {
      // 서버에서 전달해주는 해당 계정의 담당 클럽 목록(ccodes)에서 클럽 코드(ccode)값을 받을지 선택합니다.
      this.setClubIndex(index)

      // 페이지를 홈으로 이동하면서, 사용자 정보를 서버로 부터 전달받아 초기화 하기 위함.
      this.moveMenu('/')
    }
  },

  async mounted() {
    this.initFetch()
  },

  watch: {
    userInfo(value) {
      if (value && !this.clubs) this.initFetch()
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.title {
  color: #222;
  font-weight: 200;
  font-size: 32px;
}

/* Club start */
.club {
  list-style: none;
  display: flex;
  gap: 10px;
}

.club__item {
  padding: 16px 20px;
  border: #e6e6e6 1px solid;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.club__item.active {
  border-color: #d0202e;
}
/* Club end */
</style>



// WEBPACK FOOTER //
// src/pages/AccountClubs.vue